export function IntroSection() {
    return (
        <section id="intro-section">

            <div className="container section-body">
                <div className="text">
                    <h3>Build the Future with</h3>
                    <h1>Blockchain technology and Currency</h1>
                    <div className="btn btn-primary desktop-only">Get Whitepaper</div>
                </div>

                <div className="city-ping" />

                <div className="btn btn-primary mobile-only">Get Whitepaper</div>
            </div>
        </section>
    )
}